module.exports = __webpack_public_path__ + "static/media/kid_owl.a6598ae2.svg";